import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const getFile = (token, fileId, shouldResponseBeBlob) => {
  const tokenConfig = configurationForToken(token)
  const config = shouldResponseBeBlob ? {...tokenConfig, responseType: 'blob'} : tokenConfig;
  return apiClient.get(`/file/${fileId}?shouldReturnEncodedImage=true`, config);
};

export default {
  getFile,
};



// WEBPACK FOOTER //
// ./src/Services/FileService.js